
import React, { useState } from 'react';
import styles from './styles/ScenarioCarousels.module.css';
import ScenarioCarousel from './ScenarioCarousel'; 
import TabsBar from './TabsBar';


const ScenarioCarousels = () => {
    const [activeTab, setActiveTab] = useState('Featured'); 
    const [activeSubTab, setActiveSubTab] = useState('');

    
    
    const mapSubTabToTag = (subTabName) => {
        return subTabName.toLowerCase().replace(/\s+/g, '-');
    };

    return (
        <div className={styles.container}>
            <div className={styles.tabsWrapper}>
                <TabsBar
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    activeSubTab={activeSubTab}
                    setActiveSubTab={setActiveSubTab}
                />
            </div>
            {/* ScenarioCarousel will now fetch its own data based on these props */}
            <ScenarioCarousel
                activeTab={activeTab}
                activeSubTab={activeSubTab}
                mapSubTabToTag={mapSubTabToTag} 
            />
        </div>
    );
};

export default ScenarioCarousels;